<template>
<svg viewBox="0 0 24 24" fill="none"
	stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
	<polyline points="6 9 12 15 18 9"></polyline>
</svg>
</template>
